import React from "react";
import "./TypingIndicator.css";

export default function TypingIndicator() {
  return (
    <div className="message-row message-row--bot typing-row">
      <div className="message-avatar message-avatar--bot" aria-hidden="true">
        B
      </div>
      <div className="message-bubble-wrapper">
        <div className="message-bubble message-bubble--bot typing-bubble">
          <span className="typing-dot" />
          <span className="typing-dot" />
          <span className="typing-dot" />
        </div>
      </div>
    </div>
  );
}
